/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{background:#fff;padding:16px}.subtle[_ngcontent-%COMP%]{color:#a4a4a4;margin-top:-12px}.submit[_ngcontent-%COMP%], .submit[_ngcontent-%COMP%]:disabled{background-color:#8cc14c;color:#fff;font-size:24px;padding:18px;max-width:545px;width:100%}"];
export { styles as styles };
